<template>
  <modal
    name="setUserCategories"
    transition="nice-modal-fade"
    :width="600"
    :height="'auto'"
    :pivotY="0.3"
    @before-open="beforeOpen"
    :classes="['user-categories']"
    ref="modal"
  >
    <div
      class="container"
      @keydown.stop
    >
      <div class="header">
        <span>分类配置</span>
        <div
          class="close-btn"
          @click="clickToClose()"
        >
          <i class="icon-popup-close"></i>
        </div>
      </div>
      <div class="content">
        <ul class="list">
          <li class="list-item">
            <div class="name">
              <div class="name">默认</div>
            </div>
          </li>

          <li
            v-for="(item, i) in modalParams.list"
            class="list-item"
            ref="listItem"
          >
            <el-tooltip
              :manual="true"
              :value="isShowTooltip(i, '.myTextOverflowRef')"
              placement="top"
              :open-delay="1000"
            >
              <div
                slot="content"
                style="max-width: 380px;"
              >{{item.name}}</div>
              <div
                class="name"
                @mouseover="onMOName(i)"
                @mouseout="onMOutName()"
              >
                <div
                  class="input"
                  v-if="editingIndex === i"
                >
                  <input
                    type="text"
                    v-model="updatingCateName"
                    @blur="onClickDone(item, i)"
                    @keydown.enter="setBlur($event)"
                  />
                </div>
                <div
                  class="name myTextOverflowRef"
                  v-else
                >{{item.name}}</div>
              </div>
            </el-tooltip>

              <!-- @click="onClickDone(item, i)" -->
            <div
              v-if="editingIndex === i"
              class="item-btn done"
            >完成</div>
            <div
              class="item-btn update"
              @click="onClickUpdate(item, i)"
            >修改</div>

            <div
              class="item-btn remove"
              @click.stop="onClickRemove(item, i)"
            >删除</div>
          </li>
        </ul>

        <div
          class="adding-line"
          v-show="addingItemActive"
        >
          <div class="input">
            <input
              v-model="newCateName"
              type="text"
              @blur="addCate()"
              @keydown.enter="setBlur($event)"
            />
          </div>
          <div
            class="item-btn"
            @click="setBlur($event)"
          >完成</div>
          <div
            class="item-btn"
            @click="cancelAdding()"
          >取消</div>
        </div>
      </div>

      <div class="footer">
        <div
          class="btn"
          @click="setActiveAdding"
        >
          <i></i>
          <span>新增分类</span>
        </div>
      </div>

      <div
        class="inner-modal"
        v-show="isShowInnerModal"
      >
        <div class="dialog">
          <div class="dialog-content">{{innerModalMsg}}</div>
          <div class="dialog-footer">
            <div
              class="dialog-btn"
              @click="clickToSave()"
            >
              <span>保留</span>
            </div>
            <div
              class="dialog-btn danger"
              @click="clickToClear()"
            >
              <span>清除文件</span>
            </div>
          </div>
          <div
            class="dialog-close"
            @click="closeInnerModal()"
          >
            <i class="icon-popup-close"></i>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      modalParams: {
        requestingId: '',
        list: []
      },
      newCateName: '',
      updatingCateName: '',
      editingIndex: -1,
      addingItem: {
        name: ''
      },
      addingItemActive: false,
      isShowInnerModal: false,
      innerModalMsg: '',
      removingItem: {
        item: {},
        index: -1
      },
      hoverIndex: -1,
    }
  },
  computed: {
    cAddingItem () {
      return this.addingItemActive ? [this.addingItem] : []
    }
  },
  created () {

  },
  methods: {
    reset () {
      this.addingItemActive = false;
      this.isShowInnerModal = false;
      this.editingIndex = -1;
    },
    clickToClose () {
      this.$modal.hide(this.$refs.modal.name);
    },
    beforeOpen ({ params } = {}) {
      this.modalParams = params;
      this.reset();
    },
    addCate () {
      return this.$http.post(`/api/user/material/addCategory`, {
        name: this.newCateName,
        type: this.modalParams.requestingId,
        ourself: 1,
        fileType: 26
      })
        .then(res => {
          this.$bus.emit('setUserCategories.added', {
            id: res.data.data.id,
            name: res.data.data.name
          });
          this.addingItemActive = false;
        })
    },
    updateCate (name, item, i) {
      return this.$http.post('/api/user/material/updateCategory', {
        id: item.id + '',
        name: name,
        ourself: 1
      })
        .then(res => {
          this.$bus.emit('setUserCategories.updated', {
            id: item.id,
            name: name,
          });
        })
        .catch(err => { })
    },
    removeCategory (item, i, isClear) {
      let payload = {
        id: item.id,
        ourself: 1,
      };
      if (isClear) {
        payload.deleteMaterial = 'delete';
      }
      return this.$http.post('/api/user/material/deleteCategory', payload)
        .then(res => {
          if (res.data.code == 200) {
            this.$bus.emit('setUserCategories.removed', item, isClear, i);
            this.isShowInnerModal = false;
          }
        })
    },
    onClickUpdate (item, i) {
      if (this.editingIndex === i) {
        $(this.$refs.listItem).find('.name input').focus();
        return;
      }
      this.editingIndex = i;
      this.updatingCateName = item.name;
      this.$nextTick(() => {
        $(this.$refs.listItem).find('.name input').focus();
      });
    },
    onClickDone (item, i) {
      this.updateCate(this.updatingCateName, item, i)
        .then(() => {
          this.editingIndex = -1;
          $(this.$refs.listItem).find('.name input').blur();
        })
    },
    onClickRemove (item, i) {
      this.$http.get('/api/user/material/categoryMaterialNumber', {
        params: {
          id: item.id,
          ourself: 1,
        }
      })
        .then(res => {
          let num = res.data.data;
          if (num === 0) {
            this.removeCategory(item, i);
            return;
          }

          this.removingItem = {
            item,
            index: i
          };
          this.innerModalMsg = `删除分类后是否保留所属的${num}个文件？`;
          this.isShowInnerModal = true;
        });
    },
    cancelAdding () {
      this.addingItemActive = false;
    },
    setActiveAdding () {
      this.newCateName = '新建分类';
      this.addingItemActive = true;
      this.$nextTick(() => {
        let el = $(this.$el).find('.adding-line .input>input')[0];
        el && el.focus();
      });
    },
    closeInnerModal () {
      this.isShowInnerModal = false;
    },
    clickToSave () {
      this.removeCategory(this.removingItem.item, this.removingItem.index);
    },
    clickToClear () {
      this.removeCategory(this.removingItem.item, this.removingItem.index, true);
    },
    onMOName (index) {
      this.hoverIndex = index;
    },
    onMOutName () {
      this.hoverIndex = -1;
    },
    isShowTooltip (index, selector) {
      if (this.hoverIndex < 0) {
        return false;
      }
      let el = $(this.$el).find('.myTextOverflowRef')[0];
      if (!el) {
        return false;
      }
      let scrollWidth = el.scrollWidth;
      let offsetWidth = el.offsetWidth;
      let isOverflow = scrollWidth > offsetWidth
      return this.hoverIndex === index && isOverflow;
    },
    setBlur (ev) {
      ev.target.blur();
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  box-shadow: none;
  position: relative;
  width: 100%;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
  margin: auto;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 600px;
  height: 40px;
  background-color: #d9ddea;
  border-radius: 4px 4px 0px 0px;
  padding-left: 1.2em;
  padding-right: 1.2em;
  color: #474261;
}
.content {
  padding: 16px 0;
  color: #474261;
  background-color: #ffffff;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 40px;
  background-color: #ffffff;

  > div:nth-of-type(1) {
    margin-right: 25px;
  }
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 40px;
  background-color: #5778fb;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;

  & > i {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    background-image: url(../../../../static/svg/user-categories/new.svg);
    background-repeat: no-repeat;
  }
  &:hover {
    background-color: #5656e8;
  }
}

.close-btn {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  & > i {
    height: 16px;
    width: 16px;
  }
}
.list {
  padding-left: 60px;
  padding-right: 60px;
  max-height: 400px;
  overflow: auto;
}
.list-item {
  height: 40px;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #e7e7fb;
  & > .name {
    flex-grow: 1;
    text-align: left;
    & > .name {
      max-width: 380px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }

    & input {
      width: 160px;
      height: 32px;
      padding-left: 10px;
      padding-right: 10px;
      line-height: 32px;
      border-radius: 4px;
      border: solid 1px #e7e7fb;
      &:focus {
        border-color: #5778fb;
      }
    }
  }
  & > .item-btn {
    flex-grow: 0;
    margin-left: 20px;
    cursor: pointer;
  }
}
.adding-line {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 56px;
  padding-left: 60px;
  padding-right: 60px;
  & > .input {
    flex-grow: 1;
    text-align: left;
  }
  & > .item-btn {
    flex-grow: 0;
    margin-left: 20px;
    cursor: pointer;
  }
  & input {
    width: 160px;
    height: 32px;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 32px;
    border-radius: 4px;
    border: solid 1px #e7e7fb;
    &:focus {
      border-color: #5778fb;
    }
  }
}

.inner-modal {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(#000, 0.5);
  border-radius: 4px 4px 0 0;

  & > .dialog {
    position: relative;
    width: 462px;
    height: 220px;
    background-color: #ffffff;
    border-radius: 8px;
  }
  & .dialog-content {
    padding: 60px 20px;
  }
  & .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & .dialog-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 40px;
    background-color: #5778fb;
    border-radius: 4px;
    color: #fff;
    &:hover {
      background-color: #5656e8;
    }

    &.danger {
      margin-left: 36px;
      background-color: #ff3a3f;

      &:hover {
        background-color: #ff3a3f;
      }
    }
  }
  & .dialog-close {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/modals/setUserCategories.vue